import { type PageId, pageItemIdPathMap } from "core/configs/pageIdPathMap";
import type { ItemType } from "core/entities";
import { exhaustiveCheck } from "core/utils/exhaustiveCheck";
import { isValidURL } from "core/utils/isValidURL";
import { getParentPath } from "features/DMS/utils/getParentPath";

export function getMyLinksHref<T extends ItemType>(
  itemType: T,
  itemId: T extends "Page" ? PageId : string
): string {
  switch (itemType) {
    case "Extenso":
      return `/extenso/${itemId}`;
    case "Event":
      return `/events/${itemId}`;
    case "News":
      return `/news/${itemId}`;
    case "DmsLibrary":
      return `/dms/library/v2/${itemId}`;
    case "DmsDocument":
      return `/dms/document/${itemId}`;
    case "DmsDocNodeDocument": {
      const path = getParentPath(itemId);
      return `/dms/library/v2${path}?action=document-view&actionPath=${itemId}`;
    }
    case "DmsDocNodeLibrary":
      return `/dms/library/v2/${itemId}`;
    case "External":
      return isValidURL(itemId) ? itemId : `https://${itemId}`;
    case "Page":
      return pageItemIdPathMap[itemId as PageId] ?? "/";
    case "CMSKitPage":
      return `/${itemId}`;
    case "CMSKitBlogPost":
      return `/content/${itemId}`;
    case "Report":
      return "/404"; // not implemented yet
    case "EstimateRequest":
      return `/estimate-request/${itemId}`; // not implemented yet
    case "Unknown":
      return "/404";
    case "PowerBiReport": {
      try {
        const reportIds = JSON.parse(itemId) as unknown;
        if (
          reportIds &&
          typeof reportIds === "object" &&
          "workspaceId" in reportIds &&
          "reportId" in reportIds &&
          typeof reportIds.workspaceId === "string" &&
          typeof reportIds.reportId === "string"
        ) {
          const { workspaceId, reportId } = reportIds;
          return `/power-bi/${workspaceId}/${reportId}`;
        }
        return "/404";
      } catch {
        return "/404";
      }
    }
    default:
      exhaustiveCheck(itemType);
      return "/";
  }
}
